import React, { useContext, Fragment } from 'react';
import { vehicleContext } from '../VehicleProvider';
import EquipmentCard from './EquipmentCard';
import { Layout } from '@oneaudi/unified-web-components';
import { SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_SM } from '@oneaudi/unified-web-common';

const OptionalEquipmentContent: React.FC = () => {
  const { vehicle } = useContext(vehicleContext);
  if (!vehicle) return null;

  const { equipments, market } = vehicle;

  const { optionalEquipments } = equipments;

  const usVehicle = market === 'us' || market === 'usuc';

  return (
    <Layout
      direction={'column'}
      padding={[SYS_PAGE_MARGIN_LG, 0, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_SM]}
      data-testid="optional-equipment-wrapper"
    >
      {optionalEquipments.map((option, index) => {
        const description = option.benefits && usVehicle ? option.benefits : option.text;
        return (
          <Fragment key={index}>
            {(option.text || option.imageUrl || option.headline) && (
              <EquipmentCard
                copy={option.headline}
                img={option.imageUrl}
                description={description}
                id={`optionalEquipment${index}VDPFSS`}
              />
            )}
          </Fragment>
        );
      })}
    </Layout>
  );
};

export default OptionalEquipmentContent;
